import { render, staticRenderFns } from "./Fkin.vue?vue&type=template&id=1fbf3151&scoped=true&"
import script from "./Fkin.vue?vue&type=script&lang=js&"
export * from "./Fkin.vue?vue&type=script&lang=js&"
import style0 from "./Fkin.vue?vue&type=style&index=0&id=1fbf3151&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf3151",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCard,QCardSection})
